import { Component, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { ChatProgressService } from '@services/chat-progress-service/chat-progress.service';

@Component({
  selector: 'chat-progress-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './chat-progress-bar.component.html',
})
export class ChatProgressBarComponent {
  readonly stickyTopClass = input<'tw-top-14' | 'tw-top-12'>('tw-top-14');

  private readonly chatProgressService = inject(ChatProgressService);
  protected readonly progress$: Observable<number> = this.chatProgressService.getChatProgressState();
}
